<script>
import BookingListTabKey from '@/shared/constants/booking/BookingListTabKey'

export default {
  name: 'EmptyBookingsFound',
  props: {
    currentTabName: { type: String, required: true },
  },
  computed: {
    formattedTabName() {
      if (this.currentTabName === BookingListTabKey.all) return ''

      return this.currentTabName
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .toLowerCase()
    },
    shouldShowCreateBookingActions() {
      return (
        this.currentTabName === BookingListTabKey.upcoming ||
        this.currentTabName === BookingListTabKey.all
      )
    },
    emptyBookingHeading() {
      switch (this.currentTabName) {
        case BookingListTabKey.approvalRequired:
          return this.$t('emptyBookings.approvalRequired.label')
        default:
          return this.$t('emptyBookings.label', { tab: this.formattedTabName })
      }
    },
    emptyBookingLabel() {
      return this.shouldShowCreateBookingActions
        ? this.$t('emptyBookings.paragraph')
        : this.$t('emptyBookings.adjustDateRange')
    },
  },
}
</script>

<template>
  <div class="empty-block">
    <div class="content">
      <h1>{{ emptyBookingHeading }}</h1>
      <p>
        {{ emptyBookingLabel }}
      </p>

      <div v-if="shouldShowCreateBookingActions" class="button">
        <BaseButton
          class="create-booking-btn"
          prepend-icon="mdi mdi-plus"
          width="170"
          @click="$router.push({ name: 'bookings-create' })"
        >
          {{ $t('bookingCreate.submitBtn') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/no-booking-found.scss';
</style>
